<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Dados Pessoais">
        <NxInputDocument @update:value="handleInputUpdate('document', $event)"/>
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)"/>
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectFuncionario :variable="employeeTypes.GERENTE" @update:value="handleSelectUpdate('gerenteId', $event)"/>
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario :variable="employeeTypes.RESPONSAVEL" @update:value="handleSelectUpdate('responsavelId', $event)"/>
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto @update:value="handleSelectUpdate('produtosId', $event)" />
      </SearchCollapse>

      <SearchCollapse title="Alteração">
        <NxSelectFuncionario :variable="employeeTypes.USERALT" @update:value="handleSelectUpdate('ultimoUsuario', $event)"/>
        <NxInputDateRange
        label="Período de Referência:"
        @update:InitialValue="handleInputDateUpdate('dataSituacaoInicial', $event, false)"
        @update:FinalValue="handleInputDateUpdate('dataSituacaoFinal', $event, false)"
        />
      </SearchCollapse>

    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import {NxSelectPA, NxSelectRegional, NxSelectFuncionario, NxSelectProduto} from '@/components/nexum/components/custom-selects/index.js'
import {NxInputDocument, NxInputName, NxInputDateRange} from '@/components/nexum/components/custom-inputs/index.js'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPA, NxSelectRegional, NxSelectProduto, NxSelectFuncionario, NxInputDocument, NxInputName, NxInputDateRange },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        gerenteId: null,
        responsavelId: null,
        produtosId: null,
        ultimoUsuario: null,
        dataSituacaoInicial: null,
        dataSituacaoFinal: null
      },
      employeeTypes: employeeTypes
    }
  },
  methods: {
    debugLog () {
      console.log(this.form)
    },
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      console.log(this.form.nome)
      this.form[dataPropName] = encodeURIComponent(value)
      console.log(this.form.nome)
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If to clear multiple select
      console.log(fieldName, selectedValue)
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let parts = inputedValue.split('-')
        let reversed = parts.reverse()
        let newDate = reversed.join('/')
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/card/search/SidebarCard.vue